<template>
  <div class="app-wrap" :style="themeStyleVars">
    <NuxtRouteAnnouncer />
    <NuxtLoadingIndicator
      color="linear-gradient(90deg, #7dd3c7 0%, #8ecdf8 52%, #b7e3ff 100%)"
      :height="3"
      :throttle="120"
      :duration="1600"
      :hide-delay="180"
    />
    <GlobalRouteLoading />
    <NuxtLayout name="default" v-if="isUserCenterRoute">
      <NuxtPage />
    </NuxtLayout>
    <NuxtPage v-else />
  </div>
</template>
<script setup>
import { computed, onMounted, watch, onBeforeMount } from "vue";
import { useRoute } from "#app";
import { useMainStore } from "@/composables/store";
import { setToken, setMallAppToken, setIsErpBuyMode, isErpBuyMode } from "@/utils/globalData";
import { useLanguageDetection } from "@/composables/useLanguageDetection";
import { get } from "lodash-es";
import config from "@/config/index";
import {
  DEFAULT_THEME_COLOR,
  getSavedThemeColor,
  getThemeCssVars,
  resolveThemeColor,
  changeTheme,
} from "@/utils/themeColor";

 
const store = useMainStore();
const route = useRoute();
const isUserCenterRoute = computed(() => {
  return (
    route.path === "/user-center"
    || route.path.startsWith("/user-center/")
    || route.path === "/collection/estimation"
     
  );
});
const currentUserSyncPath = computed(() => {
  return route.fullPath;
});
const mallSiteThemeColor = computed(() => {
  return get(store.getMallSiteConfig(), "mallPcTheme");
});
const activeThemeColor = computed(() => {
  return resolveThemeColor(
    mallSiteThemeColor.value,
    process.client ? getSavedThemeColor() : "",
    DEFAULT_THEME_COLOR
  );
});
const themeStyleVars = computed(() => getThemeCssVars(activeThemeColor.value));

function getFirstQueryValue(value) {
  return Array.isArray(value) ? value[0] : value;
}

// 语言检测功能
const { autoSwitchLanguage } = useLanguageDetection();
 
onBeforeMount(() => {
  if (process.client) {
    const nextJyToken = getFirstQueryValue(route.query.setJyToken);
    const nextMallToken = getFirstQueryValue(route.query.setMallToken);
    if (nextJyToken) {
      // 手工直接设置token进到系统
        setToken(nextJyToken);
    }
    if (nextMallToken) {
      setMallAppToken(nextMallToken);
    }

    if(process.client){
      if (route.query.isTbPurchaseOrderMode) {
        window.localStorage.setItem(config.isTbPurchaseOrderModeKey,"1");
      }else{
        window.localStorage.removeItem(config.isTbPurchaseOrderModeKey);
      }
    }
    console.log(window.location.pathname,'window.location.pathname',route.query.batchBindMallOrder==1|| isErpBuyMode())
    if ( (window.location.pathname=='/' || window.location.pathname=='/product/search' ) && (route.query.batchBindMallOrder==1|| isErpBuyMode())) {
      // 采购模式进到系统
      setIsErpBuyMode(true);
    } 
    
  }
})
onMounted(async () => {
  if (process.client) {
    // 首次访问时自动检测并切换语言
    autoSwitchLanguage();
  }
});

async function changeThemeColor() {
  if (process.client) {
    changeTheme(activeThemeColor.value);
  }
}
onBeforeMount(async () => {
  if (process.client) {
    store.initCurrentCurrency();
    changeThemeColor();
    await store.getCurrentUserData();
  }
});
if (process.client) {
  watch(
    () => [currentUserSyncPath.value, route.query.setJyToken, route.query.setMallToken],
    async () => {
      changeThemeColor();
      await store.getCurrentUserData();
    },
    { immediate: false }
  );
}
</script>
<style>
.page-enter-active,
.page-leave-active {
  transition: all 0.4s;
}

.page-enter-from,
.page-leave-to {
  opacity: 0;
  filter: blur(1rem);
}

.layout-enter-active,
.layout-leave-active {
  transition: all 0.4s;
}

.layout-enter-from,
.layout-leave-to {
  filter: grayscale(1);
}

.flex-col {
  display: flex;

}

.flex-row {
  display: flex;

}
</style>
